// extracted by mini-css-extract-plugin
export default {"search-bar":"NldfmtsvkqRLA1Xp72FA","dropdown":"BfSqfTUS7pkxV535ArXh"};